(function hbSelleasyPopupQtyFixSafe() {



  // ===== Singleton guard (sehr wichtig) =====



  if (window.__hbSelleasyFixLoaded) return;

  window.__hbSelleasyFixLoaded = true;



  // ===== State =====



  let lastTeethCount = 1; // Zähne gesamt = (Zähne pro Löffel) * (Löffel-Menge)

  let lastInStock = true;



  // ===== Utils =====



  const norm = (s) => (s || "").toLowerCase().replace(/\s+/g, " ").trim();

  const isVisible = (el) => !!(el && el.getClientRects && el.getClientRects().length);



  // Deep walk NUR innerhalb eines Roots (Popup), nicht global

  function deepWalk(root, cb) {

    if (!root) return;



    cb(root);



    // light dom

    if (root.querySelectorAll) {

      root.querySelectorAll("*").forEach(cb);

    }



    // shadow dom (open)

    const nodes = root.querySelectorAll ? root.querySelectorAll("*") : [];

    for (const el of nodes) {

      if (el.shadowRoot) deepWalk(el.shadowRoot, cb);

    }

  }



  function findPopupRootFast() {

    // Selleasy Popup ist sichtbar, wenn der Titel existiert (wie bei dir)

    const titleEl = Array.from(document.querySelectorAll("body *")).find((el) => {

      if (!isVisible(el)) return false;



      const t = norm(el.textContent);

      return t.includes("entdecken sie passende artikel");

    });



    if (!titleEl) return null;



    // zum Container hochlaufen

    let c = titleEl;



    for (let i = 0; i < 12; i++) {

      if (!c) break;



      if (isVisible(c) && c.clientWidth > 260 && c.clientHeight > 220) return c;



      c = c.parentElement || c.host || null;

    }



    return titleEl;

  }



  function readTeethFromPage() {

    const els = Array.from(document.querySelectorAll("[data-hb-teeth-count]"));



    for (const el of els) {

      if (el.hasAttribute("data-hb-teeth-disabled")) continue;



      const v = parseInt(el.value, 10);

      if (Number.isFinite(v) && v > 0) return v;

    }



    return lastTeethCount || 1;

  }



  // FIX: Menge auch dann finden, wenn Quantity-Input NICHT im <form> steckt,

  // sondern nur per form="product-form-..." verknüpft ist (Focal Standard)

  function readMainQtyFromTrigger(triggerEl) {

    // triggerEl kann Button oder Form sein

    const form =

      triggerEl && triggerEl.tagName && triggerEl.tagName.toLowerCase() === "form"

        ? triggerEl

        : triggerEl && triggerEl.closest

        ? triggerEl.closest("form")

        : null;



    let qtyEl = null;



    // 1) Versuch: direkt im Form

    if (form) {

      qtyEl =

        form.querySelector('input[name="quantity"]:not([disabled])') ||

        form.querySelector('input[name="quantity"]');

    }



    // 2) Fallback: Input hängt evtl. außerhalb, aber mit form="<form.id>"

    if (!qtyEl && form && form.id) {

      qtyEl = document.querySelector(

        `input[name="quantity"][form="${CSS.escape(form.id)}"]`

      );

    }



    // 3) Letzter Fallback

    if (!qtyEl) {

      const candidates = Array.from(

        document.querySelectorAll('input[name="quantity"]')

      ).filter(isVisible);



      if (candidates.length === 1) qtyEl = candidates[0];

    }



    const q = qtyEl ? parseInt(qtyEl.value, 10) : 1;

    return Number.isFinite(q) && q > 0 ? q : 1;

  }



  function readInStockFromClickSource(triggerEl) {

    // Primär: Lieferzeit-Property aus deinem Add-to-cart Form

    const form = triggerEl && triggerEl.closest

      ? triggerEl.closest("form")

      : null;



    if (form) {

      const lz = form.querySelector("input[name='properties[Lieferzeit]']");



      if (lz && lz.value) {

        const v = norm(lz.value);



        if (

          v.includes("woche") ||

          v.includes("wochen") ||

          v.includes("4–6") ||

          v.includes("4-6")

        ) {

          return false;

        }

      }

    }



    // Fallback

    const badge = document.querySelector(

      ".inventoryNote, .label--subdued, .label2, .label1"

    );



    if (badge) {

      const t = norm(badge.textContent);



      if (

        t.includes("bestellbar") ||

        t.includes("4–6") ||

        t.includes("4-6")

      ) {

        return false;

      }



      if (

        t.includes("sofort verfügbar") ||

        t.includes("auf lager")

      ) {

        return true;

      }

    }



    return true;

  }



  // Capture state beim Klick / Submit

  document.addEventListener(

    "click",

    (e) => {

      const btn =

        e.target &&

        e.target.closest &&

        e.target.closest(

          "[data-product-add-to-cart-button], button[type='submit']"

        );



      if (!btn) return;



      const teethPerBucket = readTeethFromPage();

      const mainQty = readMainQtyFromTrigger(btn);



      lastTeethCount = teethPerBucket * mainQty;

      lastInStock = readInStockFromClickSource(btn);

    },

    true

  );



  document.addEventListener(

    "submit",

    (e) => {

      const form = e.target;



      if (!form || !form.querySelector) return;

      if (!form.querySelector("input[name='id']")) return;



      const teethPerBucket = readTeethFromPage();

      const mainQty = readMainQtyFromTrigger(form);



      lastTeethCount = teethPerBucket * mainQty;

      lastInStock = readInStockFromClickSource(form);

    },

    true

  );



  // ===== Popup helpers =====



  function setInputValue(input, qty) {

    if (!input) return;



    input.value = String(qty);

    input.dispatchEvent(new Event("input", { bubbles: true }));

    input.dispatchEvent(new Event("change", { bubbles: true }));

  }



  function findCard(popupRoot, predicateText) {

    let hit = null;



    deepWalk(popupRoot, (n) => {

      if (hit) return;

      if (!n || n.nodeType !== 1) return;

      if (!isVisible(n)) return;



      if (

        n.tagName &&

        n.tagName.toLowerCase() === "lb-upsell-flat-card"

      ) {

        const t = norm(n.textContent);



        if (predicateText(t)) hit = n;

      }

    });



    return hit;

  }



  function findCheckbox(card) {

    let cb = null;



    deepWalk(card.shadowRoot || card, (n) => {

      if (cb) return;



      if (

        n &&

        n.nodeType === 1 &&

        n.matches &&

        n.matches("input[type='checkbox'], input[type='radio']")

      ) {

        cb = n;

      }

    });



    return cb;

  }



  function findQtyInput(card) {

    let input = null;



    deepWalk(card.shadowRoot || card, (n) => {

      if (input) return;

      if (!n || n.nodeType !== 1 || !n.matches) return;



      if (n.matches("input.lb-qty-count")) {

        input = n;

      } else if (n.matches("input[type='number'][name*='qty' i]")) {

        input = n;

      } else if (

        n.matches("input[type='number'][aria-label*='Quantity' i]")

      ) {

        input = n;

      }

    });



    return input;

  }



  // ===== HB: sichtbaren Gesamtpreis im Ersatzzahn-Popup aktualisieren =====



  function parseEuroCents(text) {

    const m = String(text || "")

      .trim()

      .match(/^€?\s*(\d{1,3}(?:\.\d{3})*|\d+)\s*,\s*(\d{2})\s*€?$/);



    if (!m) return null;



    const euros = parseInt(m[1].replace(/\./g, ""), 10);

    const cents = parseInt(m[2], 10);



    if (!Number.isFinite(euros) || !Number.isFinite(cents)) return null;



    return euros * 100 + cents;

  }



  function formatEuroCents(cents) {

    const value = (Math.max(0, cents) / 100)

      .toFixed(2)

      .replace(".", ",");



    return "€" + value;

  }



  function findToothPriceElement(card) {

    let hit = null;



    deepWalk(card.shadowRoot || card, (n) => {

      if (hit || !n || n.nodeType !== 1 || !isVisible(n)) return;



      const text = String(n.textContent || "").trim();



      if (parseEuroCents(text) == null) return;



      const visibleChildren = n.children

        ? Array.from(n.children).filter(

            (c) =>

              isVisible(c) &&

              String(c.textContent || "").trim()

          )

        : [];



      if (

        visibleChildren.some(

          (c) =>

            parseEuroCents(

              String(c.textContent || "").trim()

            ) != null

        )

      ) {

        return;

      }



      hit = n;

    });



    return hit;

  }



  function syncToothDisplayPrice(card, qtyInput) {

    if (!card || !qtyInput) return;



    const priceEl = findToothPriceElement(card);



    if (!priceEl) return;



    let unitCents = parseInt(

      card.getAttribute("data-hb-unit-price-cents") || "",

      10

    );



    if (!Number.isFinite(unitCents) || unitCents <= 0) {

      unitCents = parseEuroCents(priceEl.textContent);



      if (!Number.isFinite(unitCents) || unitCents <= 0) return;



      card.setAttribute(

        "data-hb-unit-price-cents",

        String(unitCents)

      );

    }



    const qty = Math.max(

      1,

      parseInt(qtyInput.value, 10) || 1

    );



    const total = unitCents * qty;

    const next = formatEuroCents(total);



    if (

      String(priceEl.textContent || "").trim() !== next

    ) {

      priceEl.textContent = next;

    }

  }



  function hookToothDisplayPrice(card, qtyInput) {

    if (!card || !qtyInput) return;



    syncToothDisplayPrice(card, qtyInput);



    if (!qtyInput.getAttribute("data-hb-price-hooked")) {

      qtyInput.setAttribute("data-hb-price-hooked", "1");



      const sync = () => {

        [0, 40, 120, 250].forEach((delay) => {

          setTimeout(() => {

            const currentInput = findQtyInput(card);



            if (currentInput) {

              syncToothDisplayPrice(card, currentInput);

            }

          }, delay);

        });

      };



      qtyInput.addEventListener("input", sync);

      qtyInput.addEventListener("change", sync);



      const buttons = findQtyStepperButtons(card);



      if (buttons.plus) {

        buttons.plus.addEventListener("click", sync, true);

      }



      if (buttons.minus) {

        buttons.minus.addEventListener("click", sync, true);

      }

    }



    if (!card.getAttribute("data-hb-price-live")) {

      card.setAttribute("data-hb-price-live", "1");



      const liveTimer = setInterval(() => {

        if (!card.isConnected) {

          clearInterval(liveTimer);

          return;

        }



        const currentInput = findQtyInput(card);



        if (currentInput) {

          syncToothDisplayPrice(card, currentInput);

        }

      }, 120);

    }

  }



  // ===== Stock lesen =====



  function readToothStock() {

    const el = document.querySelector("[data-hb-tooth-stock]");



    if (!el) {

      return {

        hasData: false,

        inStock: true,

        maxQty: null,

        variantId: null

      };

    }



    try {

      const d = JSON.parse(el.textContent || "{}");



      const variantId =

        d.variant_id != null

          ? String(d.variant_id)

          : null;



      const managed = d.managed === "shopify";

      const qty = Number(d.qty);



      if (!variantId) {

        return {

          hasData: false,

          inStock: true,

          maxQty: null,

          variantId: null

        };

      }



      if (managed) {

        const maxQty = Number.isFinite(qty)

          ? Math.max(0, Math.floor(qty))

          : 0;



        return {

          hasData: true,

          inStock: maxQty > 0,

          maxQty,

          variantId

        };

      }



      return {

        hasData: true,

        inStock: true,

        maxQty: null,

        variantId

      };

    } catch (e) {

      return {

        hasData: false,

        inStock: true,

        maxQty: null,

        variantId: null

      };

    }

  }



  function findVariantIdInCard(card) {

    let found = null;



    deepWalk(card.shadowRoot || card, (n) => {

      if (found) return;

      if (!n || n.nodeType !== 1) return;



      const attrs = [

        "data-variant-id",

        "data-variantid",

        "variant-id",

        "data-id"

      ];



      for (const attr of attrs) {

        const v = n.getAttribute && n.getAttribute(attr);

        if (v && /^\d+$/.test(String(v).trim())) {

          found = String(v).trim();

          return;

        }

      }



      if (n.matches) {

        if (n.matches("input[name='id'], select[name='id']")) {

          const v = n.value;

          if (v && /^\d+$/.test(String(v).trim())) {

            found = String(v).trim();

            return;

          }

        }



        if (n.matches("input[name*='variant' i], input[name*='id' i]")) {

          const v = n.value;

          if (v && /^\d+$/.test(String(v).trim())) {

            found = String(v).trim();

            return;

          }

        }

      }

    });



    return found;

  }



  function getPopupAccessoryDeliveryItems() {

    const popup = findPopupRootFast();



    if (!popup) return [];



    const items = [];

    const seen = new Set();



    deepWalk(popup, (n) => {

      if (!n || n.nodeType !== 1) return;

      if (!isVisible(n)) return;



      if (!(n.tagName && n.tagName.toLowerCase() === "lb-upsell-flat-card")) {

        return;

      }



      const text = norm(n.textContent);



      const isExpress =

        text.includes("expressversand") ||

        text.includes("übernacht");



      const isHydraulicHose =

        text.includes("hydraulikschlauch") ||

        text.includes("hydraulikschläuch") ||

        text.includes("hydraulikschlaeuch") ||

        text.includes("schlauch");



      if (!isHydraulicHose || isExpress) {

        return;

      }



      const cb = findCheckbox(n);



      if (cb && !cb.checked) {

        return;

      }



      const variantId = findVariantIdInCard(n);



      if (!variantId || seen.has(variantId)) {

        return;

      }



      const qtyInput = findQtyInput(n);

      const qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);



      items.push({

        variantId,

        quantity: qty,

        delivery: "🚚 1–3 Tage bei Ihnen",

        source: "Produktseiten-Werbung"

      });



      seen.add(variantId);

    });



    return items;

  }


  function clampQty(qty, max) {

    const q = parseInt(qty, 10);

    const m = parseInt(max, 10);



    if (!Number.isFinite(q) || q <= 0) return 1;



    if (Number.isFinite(m) && m > 0) {

      return Math.min(q, m);

    }



    return q;

  }



  function setToothQty(input, desired, maxQty) {

    const qty =

      Number.isFinite(maxQty) && maxQty > 0

        ? clampQty(desired, maxQty)

        : desired;



    setInputValue(input, qty);

  }



  function applyMaxAndClamp(input, maxQty) {

    if (

      !input ||

      !Number.isFinite(maxQty) ||

      maxQty <= 0

    ) {

      return;

    }



    input.setAttribute("max", String(maxQty));



    const v = parseInt(input.value, 10);

    const fixed = clampQty(v, maxQty);



    if (String(fixed) !== String(v)) {

      setInputValue(input, fixed);

    }



    if (!input.getAttribute("data-hb-clamp-hooked")) {

      input.setAttribute("data-hb-clamp-hooked", "1");



      const handler = () => {

        const v2 = parseInt(input.value, 10);

        const fixed2 = clampQty(v2, maxQty);



        if (String(fixed2) !== String(v2)) {

          setInputValue(input, fixed2);

        }

      };



      input.addEventListener("input", handler);

      input.addEventListener("change", handler);

    }

  }



  // ===== Plus-Button im Stepper sperren =====



  function findQtyStepperButtons(card) {

    let plus = null;

    let minus = null;



    deepWalk(card.shadowRoot || card, (n) => {

      if (!n || n.nodeType !== 1 || !n.matches) return;



      if (n.matches("button")) {

        const t = norm(n.textContent);

        const al = norm(n.getAttribute("aria-label"));

        const ti = norm(n.getAttribute("title"));



        const isPlus =

          t === "+" ||

          al.includes("increase") ||

          al.includes("erhöhen") ||

          al.includes("increase quantity") ||

          ti.includes("increase") ||

          ti.includes("erhöhen");



        const isMinus =

          t === "-" ||

          al.includes("decrease") ||

          al.includes("verringern") ||

          al.includes("decrease quantity") ||

          ti.includes("decrease") ||

          ti.includes("verringern");



        if (isPlus && !plus) plus = n;

        if (isMinus && !minus) minus = n;

      }

    });



    return { plus, minus };

  }



  function syncStepperDisabled(

    input,

    plusBtn,

    minusBtn,

    maxQty

  ) {

    if (!input) return;



    const v = parseInt(input.value, 10) || 1;



    if (minusBtn) {

      minusBtn.disabled = v <= 1;

    }



    if (

      plusBtn &&

      Number.isFinite(maxQty) &&

      maxQty > 0

    ) {

      plusBtn.disabled = v >= maxQty;

    }

  }



  function hookStepperLimit(card, input, maxQty) {

    if (

      !card ||

      !input ||

      !Number.isFinite(maxQty) ||

      maxQty <= 0

    ) {

      return;

    }



    if (card.getAttribute("data-hb-stepper-hooked")) return;



    card.setAttribute("data-hb-stepper-hooked", "1");



    const { plus, minus } =

      findQtyStepperButtons(card);



    const resync = () =>

      syncStepperDisabled(

        input,

        plus,

        minus,

        maxQty

      );



    resync();



    input.addEventListener(

      "input",

      () => setTimeout(resync, 0)

    );



    input.addEventListener(

      "change",

      () => setTimeout(resync, 0)

    );



    if (plus) {

      plus.addEventListener(

        "click",

        () => setTimeout(resync, 0),

        true

      );

    }



    if (minus) {

      minus.addEventListener(

        "click",

        () => setTimeout(resync, 0),

        true

      );

    }

  }



  // ===== HARTER REQUEST-CLAMP =====



  function isCartEndpoint(url) {

    const u = String(url || "");



    return (

      u.includes("/cart/add") ||

      u.includes("/cart/update") ||

      u.includes("/cart/change")

    );

  }



  function clampJsonBody(

    obj,

    toothVariantId,

    maxQty

  ) {

    if (

      !obj ||

      !toothVariantId ||

      !Number.isFinite(maxQty)

    ) {

      return obj;

    }



    if (

      obj.id != null &&

      String(obj.id) === String(toothVariantId) &&

      obj.quantity != null

    ) {

      const q = parseInt(obj.quantity, 10);



      if (Number.isFinite(q) && q > maxQty) {

        obj.quantity = maxQty;

      }



      if (Number.isFinite(q) && q < 1) {

        obj.quantity = 1;

      }



      return obj;

    }



    if (Array.isArray(obj.items)) {

      obj.items = obj.items.map((it) => {

        if (!it) return it;



        if (

          it.id != null &&

          String(it.id) === String(toothVariantId) &&

          it.quantity != null

        ) {

          const q = parseInt(it.quantity, 10);



          if (

            Number.isFinite(q) &&

            q > maxQty

          ) {

            it.quantity = maxQty;

          }



          if (

            Number.isFinite(q) &&

            q < 1

          ) {

            it.quantity = 1;

          }

        }



        return it;

      });



      return obj;

    }



    if (

      obj.updates &&

      typeof obj.updates === "object"

    ) {

      const key = String(toothVariantId);



      if (obj.updates[key] != null) {

        const q = parseInt(

          obj.updates[key],

          10

        );



        if (

          Number.isFinite(q) &&

          q > maxQty

        ) {

          obj.updates[key] = maxQty;

        }



        if (

          Number.isFinite(q) &&

          q < 1

        ) {

          obj.updates[key] = 1;

        }

      }



      return obj;

    }



    return obj;

  }



  function clampUrlEncodedBody(

    bodyStr,

    toothVariantId,

    maxQty

  ) {

    if (

      !bodyStr ||

      !toothVariantId ||

      !Number.isFinite(maxQty)

    ) {

      return bodyStr;

    }



    try {

      const usp =

        new URLSearchParams(bodyStr);



      const id = usp.get("id");



      if (

        id &&

        String(id) === String(toothVariantId)

      ) {

        const q = parseInt(

          usp.get("quantity") || "1",

          10

        );



        if (

          Number.isFinite(q) &&

          q > maxQty

        ) {

          usp.set(

            "quantity",

            String(maxQty)

          );

        }



        if (

          Number.isFinite(q) &&

          q < 1

        ) {

          usp.set("quantity", "1");

        }



        return usp.toString();

      }



      const key =

        `updates[${toothVariantId}]`;



      if (usp.has(key)) {

        const q = parseInt(

          usp.get(key) || "1",

          10

        );



        if (

          Number.isFinite(q) &&

          q > maxQty

        ) {

          usp.set(

            key,

            String(maxQty)

          );

        }



        if (

          Number.isFinite(q) &&

          q < 1

        ) {

          usp.set(key, "1");

        }



        return usp.toString();

      }



      for (let i = 0; i < 50; i++) {

        const kId =

          `items[${i}][id]`;



        const kQty =

          `items[${i}][quantity]`;



        if (!usp.has(kId)) continue;



        if (

          String(usp.get(kId)) ===

          String(toothVariantId)

        ) {

          const q = parseInt(

            usp.get(kQty) || "1",

            10

          );



          if (

            Number.isFinite(q) &&

            q > maxQty

          ) {

            usp.set(

              kQty,

              String(maxQty)

            );

          }



          if (

            Number.isFinite(q) &&

            q < 1

          ) {

            usp.set(kQty, "1");

          }

        }

      }



      return usp.toString();

    } catch (e) {

      return bodyStr;

    }

  }



  function clampFormData(

    fd,

    toothVariantId,

    maxQty

  ) {

    if (

      !fd ||

      !toothVariantId ||

      !Number.isFinite(maxQty)

    ) {

      return fd;

    }



    const id = fd.get("id");



    if (

      id &&

      String(id) === String(toothVariantId)

    ) {

      const q = parseInt(

        fd.get("quantity") || "1",

        10

      );



      if (

        Number.isFinite(q) &&

        q > maxQty

      ) {

        fd.set(

          "quantity",

          String(maxQty)

        );

      }



      if (

        Number.isFinite(q) &&

        q < 1

      ) {

        fd.set("quantity", "1");

      }

    }



    const key =

      `updates[${toothVariantId}]`;



    if (fd.get(key) != null) {

      const q = parseInt(

        fd.get(key) || "1",

        10

      );



      if (

        Number.isFinite(q) &&

        q > maxQty

      ) {

        fd.set(

          key,

          String(maxQty)

        );

      }



      if (

        Number.isFinite(q) &&

        q < 1

      ) {

        fd.set(key, "1");

      }

    }



    for (let i = 0; i < 50; i++) {

      const kId =

        `items[${i}][id]`;



      const kQty =

        `items[${i}][quantity]`;



      const vid = fd.get(kId);



      if (!vid) continue;



      if (

        String(vid) ===

        String(toothVariantId)

      ) {

        const q = parseInt(

          fd.get(kQty) || "1",

          10

        );



        if (

          Number.isFinite(q) &&

          q > maxQty

        ) {

          fd.set(

            kQty,

            String(maxQty)

          );

        }



        if (

          Number.isFinite(q) &&

          q < 1

        ) {

          fd.set(kQty, "1");

        }

      }

    }



    return fd;

  }



  // ============================================================

  // NEU: properties[Lieferzeit] FÜR SELLEASY-ERSATZZAHN

  // ============================================================



  function addToothDeliveryProperty(url, body) {

    // Nur beim Hinzufügen zum Warenkorb

    if (

      !String(url || "").includes("/cart/add")

    ) {

      return body;

    }



    const stock = readToothStock();



    if (

      !stock ||

      !stock.variantId

    ) {

      return body;

    }



    const toothVariantId =

      String(stock.variantId);



    const fast =

      "🚚 1–3 Tage bei Ihnen";



    const slow =

      "🚚 4–6 Wochen bei Ihnen";



    function deliveryForQty(qty) {

      const q = Math.max(

        1,

        parseInt(qty, 10) || 1

      );



      // Shopify-Bestand vorhanden:

      // komplette gewünschte Menge muss lagernd sein

      if (

        Number.isFinite(stock.maxQty)

      ) {

        return stock.maxQty >= q

          ? fast

          : slow;

      }



      // Nicht mengenmäßig getrackt

      return stock.inStock === false

        ? slow

        : fast;

    }



    function patchObject(obj) {

      if (

        !obj ||

        typeof obj !== "object"

      ) {

        return obj;

      }



      // Einzelner Artikel

      if (

        obj.id != null &&

        String(obj.id) === toothVariantId

      ) {

        obj.properties =

          Object.assign(

            {},

            obj.properties || {},

            {

              Lieferzeit:

                deliveryForQty(

                  obj.quantity

                ),

              _Quelle: "Produktseiten-Werbung"

            }

          );

      }



      // Mehrere Artikel

      if (Array.isArray(obj.items)) {

        obj.items.forEach((it) => {

          if (

            !it ||

            String(it.id) !==

              toothVariantId

          ) {

            return;

          }



          it.properties =

            Object.assign(

              {},

              it.properties || {},

              {

                Lieferzeit:

                  deliveryForQty(

                    it.quantity

                  ),

                _Quelle: "Produktseiten-Werbung"

              }

            );

        });

      }



      return obj;

    }



    // FormData

    if (

      typeof FormData !== "undefined" &&

      body instanceof FormData

    ) {

      if (

        String(body.get("id") || "") ===

        toothVariantId

      ) {

        body.set(

          "properties[Lieferzeit]",

          deliveryForQty(

            body.get("quantity")

          )

        );

        body.set(
          "properties[_Quelle]",
          "Produktseiten-Werbung"
        );

      }



      for (let i = 0; i < 50; i++) {

        const kId =

          `items[${i}][id]`;



        const kQty =

          `items[${i}][quantity]`;



        if (

          String(body.get(kId) || "") ===

          toothVariantId

        ) {

          body.set(

            `items[${i}][properties][Lieferzeit]`,

            deliveryForQty(

              body.get(kQty)

            )

          );

          body.set(
            `items[${i}][properties][_Quelle]`,
            "Produktseiten-Werbung"
          );

        }

      }



      return body;

    }



    // JSON oder URL encoded

    if (typeof body === "string") {

      const trimmed = body.trim();



      if (

        trimmed.startsWith("{") ||

        trimmed.startsWith("[")

      ) {

        try {

          return JSON.stringify(

            patchObject(

              JSON.parse(body)

            )

          );

        } catch (e) {

          return body;

        }

      }



      try {

        const usp =

          new URLSearchParams(body);



        if (

          String(usp.get("id") || "") ===

          toothVariantId

        ) {

          usp.set(

            "properties[Lieferzeit]",

            deliveryForQty(

              usp.get("quantity")

            )

          );

          usp.set(
            "properties[_Quelle]",
            "Produktseiten-Werbung"
          );

        }



        for (

          let i = 0;

          i < 50;

          i++

        ) {

          const kId =

            `items[${i}][id]`;



          const kQty =

            `items[${i}][quantity]`;



          if (

            String(

              usp.get(kId) || ""

            ) === toothVariantId

          ) {

            usp.set(

              `items[${i}][properties][Lieferzeit]`,

              deliveryForQty(

                usp.get(kQty)

              )

            );

            usp.set(
              `items[${i}][properties][_Quelle]`,
              "Produktseiten-Werbung"
            );

          }

        }



        return usp.toString();

      } catch (e) {

        return body;

      }

    }



    if (

      body &&

      typeof body === "object"

    ) {

      return patchObject(body);

    }



    return body;

  }



  function addPopupAccessoryDeliveryProperties(url, body) {

    if (!String(url || "").includes("/cart/add")) {

      return body;

    }



    const popupItems = getPopupAccessoryDeliveryItems();



    if (!popupItems.length) {

      return body;

    }



    const popupMap = new Map(

      popupItems.map((item) => [String(item.variantId), item])

    );



    function applyProps(target, itemId, qty) {

      const hit = popupMap.get(String(itemId || ""));



      if (!hit || !target || typeof target !== "object") {

        return;

      }



      const delivery = hit.delivery || "🚚 1–3 Tage bei Ihnen";

      const source = hit.source || "Produktseiten-Werbung";



      target.properties = Object.assign({}, target.properties || {}, {

        Lieferzeit: delivery,

        _Quelle: source

      });



      if (qty != null && target.quantity == null) {

        target.quantity = qty;

      }

    }



    function patchObject(obj) {

      if (!obj || typeof obj !== "object") {

        return obj;

      }



      if (obj.id != null) {

        applyProps(obj, obj.id, obj.quantity);

      }



      if (Array.isArray(obj.items)) {

        obj.items.forEach((it) => {

          if (!it) return;

          applyProps(it, it.id, it.quantity);

        });

      }



      return obj;

    }



    if (typeof FormData !== "undefined" && body instanceof FormData) {

      const singleId = String(body.get("id") || "");

      const singleHit = popupMap.get(singleId);



      if (singleHit) {

        body.set("properties[Lieferzeit]", singleHit.delivery);

        body.set("properties[_Quelle]", singleHit.source);

      }



      for (let i = 0; i < 50; i++) {

        const kId = `items[${i}][id]`;

        const hit = popupMap.get(String(body.get(kId) || ""));



        if (!hit) continue;



        body.set(`items[${i}][properties][Lieferzeit]`, hit.delivery);

        body.set(`items[${i}][properties][_Quelle]`, hit.source);

      }



      return body;

    }



    if (typeof body === "string") {

      const trimmed = body.trim();



      if (trimmed.startsWith("{") || trimmed.startsWith("[")) {

        try {

          return JSON.stringify(patchObject(JSON.parse(body)));

        } catch (e) {

          return body;

        }

      }



      try {

        const usp = new URLSearchParams(body);



        const singleId = String(usp.get("id") || "");

        const singleHit = popupMap.get(singleId);



        if (singleHit) {

          usp.set("properties[Lieferzeit]", singleHit.delivery);

          usp.set("properties[_Quelle]", singleHit.source);

        }



        for (let i = 0; i < 50; i++) {

          const kId = `items[${i}][id]`;

          const hit = popupMap.get(String(usp.get(kId) || ""));



          if (!hit) continue;



          usp.set(`items[${i}][properties][Lieferzeit]`, hit.delivery);

          usp.set(`items[${i}][properties][_Quelle]`, hit.source);

        }



        return usp.toString();

      } catch (e) {

        return body;

      }

    }



    if (body && typeof body === "object") {

      return patchObject(body);

    }



    return body;

  }



  function clampRequestIfNeeded(

    url,

    body

  ) {

    if (!isCartEndpoint(url)) {

      return body;

    }



    const stock =

      readToothStock();



    if (

      !stock ||

      !stock.variantId ||

      !Number.isFinite(stock.maxQty) ||

      stock.maxQty <= 0

    ) {

      return body;

    }



    const toothVariantId =

      stock.variantId;



    const maxQty =

      stock.maxQty;



    if (typeof body === "string") {

      const trimmed =

        body.trim();



      if (

        trimmed.startsWith("{") ||

        trimmed.startsWith("[")

      ) {

        try {

          const obj =

            JSON.parse(body);



          const clamped =

            clampJsonBody(

              obj,

              toothVariantId,

              maxQty

            );



          return JSON.stringify(

            clamped

          );

        } catch (e) {}

      }



      return clampUrlEncodedBody(

        body,

        toothVariantId,

        maxQty

      );

    }



    if (

      typeof FormData !== "undefined" &&

      body instanceof FormData

    ) {

      return clampFormData(

        body,

        toothVariantId,

        maxQty

      );

    }



    if (

      body &&

      typeof body === "object"

    ) {

      return clampJsonBody(

        body,

        toothVariantId,

        maxQty

      );

    }



    return body;

  }



  // ===== FETCH PATCH =====



  const _fetch = window.fetch;



  window.fetch =

    function patchedFetch(

      input,

      init

    ) {

      try {

        const url =

          typeof input === "string"

            ? input

            : (input && input.url) ||

              "";



        if (!isCartEndpoint(url)) {

          return _fetch.apply(

            this,

            arguments

          );

        }



        if (

          !init ||

          !("body" in init) ||

          init.body == null

        ) {

          return _fetch.apply(

            this,

            arguments

          );

        }



        // Zuerst Lieferzeit ergänzen

        let newBody =

          addToothDeliveryProperty(

            url,

            init.body

          );



        newBody =

          addPopupAccessoryDeliveryProperties(

            url,

            newBody

          );



        // Danach bestehende Mengenbegrenzung

        newBody =

          clampRequestIfNeeded(

            url,

            newBody

          );



        if (

          newBody === init.body

        ) {

          return _fetch.apply(

            this,

            arguments

          );

        }



        const nextInit =

          Object.assign(

            {},

            init,

            {

              body: newBody

            }

          );



        return _fetch.call(

          this,

          input,

          nextInit

        );

      } catch (e) {

        return _fetch.apply(

          this,

          arguments

        );

      }

    };



  // ===== XHR PATCH =====



  const _open =

    XMLHttpRequest.prototype.open;



  const _send =

    XMLHttpRequest.prototype.send;



  XMLHttpRequest.prototype.open =

    function patchedOpen(

      method,

      url

    ) {

      this.__hb_url = url;



      return _open.apply(

        this,

        arguments

      );

    };



  XMLHttpRequest.prototype.send =

    function patchedSend(body) {

      try {

        const url =

          this.__hb_url || "";



        if (!isCartEndpoint(url)) {

          return _send.apply(

            this,

            arguments

          );

        }



        if (body == null) {

          return _send.apply(

            this,

            arguments

          );

        }



        // Zuerst Lieferzeit ergänzen

        let newBody =

          addToothDeliveryProperty(

            url,

            body

          );



        newBody =

          addPopupAccessoryDeliveryProperties(

            url,

            newBody

          );



        // Danach bestehende Mengenbegrenzung

        newBody =

          clampRequestIfNeeded(

            url,

            newBody

          );



        return _send.call(

          this,

          newBody

        );

      } catch (e) {

        return _send.apply(

          this,

          arguments

        );

      }

    };



  // ===== Leeres Selleasy-Popup automatisch schließen =====

  function hbClosePopupIfNoVisibleOffers(popup) {

    if (!popup) return false;

    let selectableOffers = 0;

    /*
      Nicht einfach die sichtbaren Karten zählen:
      Das bereits gekaufte Hauptprodukt wird von Selleasy ebenfalls
      im Popup angezeigt, ist aber KEIN Zusatzangebot.

      Ein echtes Zusatzangebot erkennen wir daran, dass die Karte
      eine auswählbare Checkbox / Radio besitzt.
    */
    deepWalk(popup, (n) => {

      if (!n || n.nodeType !== 1) return;

      if (

        n.tagName &&

        n.tagName.toLowerCase() === "lb-upsell-flat-card" &&

        isVisible(n) &&

        n.style.display !== "none"

      ) {

        const cb = findCheckbox(n);

        if (cb && isVisible(cb)) {

          selectableOffers++;

        }

      }

    });



    if (selectableOffers > 0) return false;



    let closeButton = null;

    deepWalk(popup, (n) => {

      if (closeButton) return;

      if (!n || n.nodeType !== 1 || !n.matches) return;



      if (!n.matches("button, [role='button']")) return;



      const aria = norm(n.getAttribute("aria-label") || "");

      const title = norm(n.getAttribute("title") || "");

      const txt = norm(n.textContent || "");



      if (

        aria.includes("close") ||

        aria.includes("schließ") ||

        aria.includes("schliess") ||

        title.includes("close") ||

        title.includes("schließ") ||

        title.includes("schliess") ||

        txt === "×" ||

        txt === "x" ||

        txt === "✕"

      ) {

        closeButton = n;

      }

    });



    if (closeButton) {

      closeButton.click();

      return true;

    }



    return false;

  }



  function hbIsGreiferadapterProductPage() {

    const titleCandidates = Array.from(
      document.querySelectorAll(
        'h1, .product-meta__title, [data-product-title]'
      )
    );

    return titleCandidates.some((el) => {
      const t = norm(el.textContent || '');
      return t.includes('greiferadapter');
    });

  }



  function hbSkipSelleasyPopupGlobal() {

    let skip = null;

    deepWalk(document.body, (n) => {

      if (skip) return;
      if (!n || n.nodeType !== 1) return;
      if (!isVisible(n)) return;

      const t = norm(n.textContent || "");

      if (
        t === "dieses angebot überspringen" ||
        t.includes("dieses angebot überspringen")
      ) {
        if (
          n.matches &&
          n.matches("button, a, [role='button']")
        ) {
          skip = n;
          return;
        }

        if (n.closest) {
          const clickable = n.closest("button, a, [role='button']");
          if (clickable) {
            skip = clickable;
          }
        }
      }

    });

    if (skip && typeof skip.click === "function") {
      skip.click();
      return true;
    }

    return false;

  }



  function hbClosePopupNow(popup) {

    if (!popup) return false;

    let closeButton = null;

    deepWalk(popup, (n) => {

      if (closeButton) return;
      if (!n || n.nodeType !== 1 || !n.matches) return;
      if (!n.matches("button, [role='button']")) return;

      const aria = norm(n.getAttribute("aria-label") || "");
      const title = norm(n.getAttribute("title") || "");
      const txt = norm(n.textContent || "");

      if (
        aria.includes("close") ||
        aria.includes("schließ") ||
        aria.includes("schliess") ||
        title.includes("close") ||
        title.includes("schließ") ||
        title.includes("schliess") ||
        txt === "×" ||
        txt === "x" ||
        txt === "✕"
      ) {
        closeButton = n;
      }

    });

    if (closeButton) {
      closeButton.click();
      return true;
    }

    return false;

  }



  // ===== Hauptlogik =====



  function applyToPopupOnce() {

    const popup =

      findPopupRootFast();



    if (!popup) return;



    // Greiferadapter bekommen grundsätzlich KEIN Selleasy-Zubehör-Popup.
    // Diese Produkte benötigen bei uns weder Zähne noch Hydraulikschläuche.
    if (hbIsGreiferadapterProductPage() && !lastInStock) {

      if (!hbSkipSelleasyPopupGlobal()) {
        hbClosePopupNow(popup);
      }

      return;

    }



    if (!lastInStock) {

      const express = findCard(

        popup,

        (t) =>

          t.includes(

            "expressversand"

          ) ||

          t.includes("übernacht")

      );



      if (express) {

        const cb =

          findCheckbox(express);



        if (

          cb &&

          cb.checked

        ) {

          cb.click();

        }



        express.style.display =

          "none";

      }

    }



    const tooth = findCard(

      popup,

      (t) =>

        t.includes(

          "ersatzzahn"

        ) ||

        (

          t.includes("zahn") &&

          (

            t.includes("kl2") ||

            t.includes("kl3") ||

            t.includes("kl4")

          )

        )

    );



    if (!tooth) {

      hbClosePopupIfNoVisibleOffers(popup);

      return;

    }



    const stock =

      readToothStock();



    if (

      stock.hasData &&

      stock.inStock === false

    ) {

      const cbOff =

        findCheckbox(tooth);



      if (

        cbOff &&

        cbOff.checked

      ) {

        cbOff.click();

      }



      tooth.style.display =

        "none";



      hbClosePopupIfNoVisibleOffers(popup);

      return;

    } else {

      tooth.style.display = "";

    }



    const cbTooth =

      findCheckbox(tooth);



    const qtyInput =

      findQtyInput(tooth);



    const maxQty =

      Number.isFinite(

        stock.maxQty

      ) &&

      stock.maxQty > 0

        ? stock.maxQty

        : null;



    if (

      Number.isFinite(maxQty)

    ) {

      lastTeethCount =

        clampQty(

          lastTeethCount,

          maxQty

        );

    }



    if (qtyInput) {

      if (

        Number.isFinite(maxQty)

      ) {

        applyMaxAndClamp(

          qtyInput,

          maxQty

        );



        hookStepperLimit(

          tooth,

          qtyInput,

          maxQty

        );

      }



      // Startmenge nur EINMAL beim Öffnen setzen.

      if (

        !tooth.getAttribute(

          "data-hb-initial-tooth-qty-set"

        )

      ) {

        tooth.setAttribute(

          "data-hb-initial-tooth-qty-set",

          "1"

        );



        setToothQty(

          qtyInput,

          lastTeethCount,

          maxQty

        );

      }



      hookToothDisplayPrice(

        tooth,

        qtyInput

      );



      syncToothDisplayPrice(

        tooth,

        qtyInput

      );



      setTimeout(() => {

        if (

          Number.isFinite(maxQty)

        ) {

          applyMaxAndClamp(

            qtyInput,

            maxQty

          );



          hookStepperLimit(

            tooth,

            qtyInput,

            maxQty

          );

        }



        syncToothDisplayPrice(

          tooth,

          qtyInput

        );

      }, 120);



      setTimeout(() => {

        if (

          Number.isFinite(maxQty)

        ) {

          applyMaxAndClamp(

            qtyInput,

            maxQty

          );



          hookStepperLimit(

            tooth,

            qtyInput,

            maxQty

          );

        }



        syncToothDisplayPrice(

          tooth,

          qtyInput

        );

      }, 320);

    }



    if (

      cbTooth &&

      !cbTooth.getAttribute(

        "data-hb-tooth-hooked"

      )

    ) {

      cbTooth.setAttribute(

        "data-hb-tooth-hooked",

        "1"

      );



      cbTooth.addEventListener(

        "change",

        () => {

          const popup2 =

            findPopupRootFast();



          if (!popup2) return;



          const tooth2 =

            findCard(

              popup2,

              (t) =>

                t.includes(

                  "ersatzzahn"

                ) ||

                (

                  t.includes("zahn") &&

                  (

                    t.includes("kl2") ||

                    t.includes("kl3") ||

                    t.includes("kl4")

                  )

                )

            );



          if (!tooth2) return;



          const qty2 =

            findQtyInput(tooth2);



          if (!qty2) return;



          const stock2 =

            readToothStock();



          const max2 =

            Number.isFinite(

              stock2.maxQty

            ) &&

            stock2.maxQty > 0

              ? stock2.maxQty

              : null;



          if (

            Number.isFinite(max2)

          ) {

            applyMaxAndClamp(

              qty2,

              max2

            );



            hookStepperLimit(

              tooth2,

              qty2,

              max2

            );

          }



          // Nutzer-Menge NICHT zurücksetzen

          hookToothDisplayPrice(

            tooth2,

            qty2

          );



          syncToothDisplayPrice(

            tooth2,

            qty2

          );



          setTimeout(() => {

            syncToothDisplayPrice(

              tooth2,

              qty2

            );

          }, 120);

        }

      );

    }

  }



  // Greiferadapter: verzögert erscheinendes Selleasy-Popup sofort überspringen
  if (hbIsGreiferadapterProductPage()) {

    const hbGreiferPopupObserver = new MutationObserver(() => {

      if (lastInStock) return;

      const popup = findPopupRootFast();

      if (!popup) return;

      if (!hbSkipSelleasyPopupGlobal()) {
        hbClosePopupNow(popup);
      }

    });

    hbGreiferPopupObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

  }



  // ===== Debounced observer =====



  let scheduled = false;

  let timer = null;



  function scheduleApply() {

    if (scheduled) return;



    scheduled = true;



    timer = setTimeout(() => {

      scheduled = false;



      applyToPopupOnce();



      setTimeout(

        applyToPopupOnce,

        120

      );



      setTimeout(

        applyToPopupOnce,

        320

      );

    }, 80);

  }



  const mo =

    new MutationObserver(

      () => scheduleApply()

    );



  mo.observe(

    document.documentElement,

    {

      childList: true,

      subtree: true

    }

  );



  setTimeout(

    scheduleApply,

    800

  );



})();





/* === HB: Sticky ATC -> trigger main PDP ATC (Selleasy Popup) === */



(function hbStickyAtcProxy() {



  if (

    window.__hbStickyAtcProxyLoaded

  ) {

    return;

  }



  window.__hbStickyAtcProxyLoaded =

    true;



  function findMainPdpAtcButton() {

    const btns =

      document.querySelectorAll(

        '[data-product-add-to-cart-button], button[name="add"]'

      );



    for (const btn of btns) {

      if (!btn) continue;



      if (

        btn.id ===

        "StickyAddToCart"

      ) {

        continue;

      }



      if (

        btn.closest(

          "product-sticky-form"

        )

      ) {

        continue;

      }



      if (

        btn.closest(

          "cart-drawer, #CartDrawer, [data-cart-drawer]"

        )

      ) {

        continue;

      }



      return btn;

    }



    return null;

  }



  document.addEventListener(

    "click",

    (e) => {

      const stickyBtn =

        e.target &&

        e.target.closest &&

        e.target.closest(

          "#StickyAddToCart,[data-hb-sticky-atc]"

        );



      if (!stickyBtn) return;



      const mainBtn =

        findMainPdpAtcButton();



      if (mainBtn) {

        mainBtn.click();

        return;

      }



      console.warn(

        "[HB Sticky ATC] Main PDP add-to-cart button not found"

      );

    },

    true

  );



})();